export default "__VITE_ASSET__GTCqJ5GV__"